<template>
  <el-dialog
    title="修改记录"
    :visible.sync="editLogDialogShow"
    width="1200px"
    append-to-body
    :close-on-click-modal="false"
  >
    <public-table :table="tableDataP" >
      <template v-for="(k,indexx) in imgListTitle"  :slot='k' slot-scope='props' >
        <div style="width: 100%;display: inline-block;">
          <el-image
            v-for='(d,index9) in props.scope.row[k]'
            :key='index9'
             style="width: 30px;height:30px;display: block;"
            :src="d.url"
            :preview-src-list="[d.url]">
        </el-image>
        </div>
      </template>
    </public-table>
  </el-dialog>
</template>

<script>
  import publicTable from '@/components/publicTable'
  export default {
    components:{
      publicTable
    },
    data() {
      return {
        editLogDialogShow:false,
        tableDataP: {
        	editWidth:null,     // 屏幕宽度
        	Maxheight: 400,				// 限定高度
        	isNotSuspensionShow: true,  // 不显示悬浮效果
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,			// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	hasShowPagination: false,	// 是否显示分页
        	config: [],
        	data: [],

        	page: {
        		pageNo: 1,
        		pageSize: 20,
        		count: 10
        	},
        	center: {
        		textAlign: 'center'
        	}
        },
        imgListTitle:[],
      }
    },
    methods:{
      getRow(row) {
        this.editLogDialogShow = true;
        this.getEditDataH(row);;
      },
      // 获取修改数据表头
      getEditDataH(row) {
      	this.$http.post('journal/getUpdateJournalTitle',{type:"1"}).then(res=>{
      		if(res.data&&res.data.code==1) {
      			this.getEditData(row);
      			this.imgListTitle = [];
      			this.tableDataP.config = res.data.data.map((i)=>{
      				if(i.customType==5) {
      					i.show='template';
      					this.imgListTitle.push(i.value);
      				}else {
      					i.show='normal';
      				}
              i.width = 160;
      				i.label = i.columnName;
      				return i;
      			})
      		}
      	})
      },
      // 获取修改数据
      getEditData(row) {
      	this.$http.post('journal/getUpdateJournal',{id:row.id}).then(res=>{
      		if(res.data&&res.data.code==1) {
      			this.tableDataP.data = res.data.data;
      		}
      	})
      },
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-edit-logList.vue